import { useTranslation } from 'react-i18next';
import TypeRichText from '../../../form/form-fields/TypeRichText';
import { useEffect, useState } from 'react';
import { FormFieldsHighlightContainer } from '../../../form/FormFieldsHighlightContainer';

export const MatchingPropLeadFieldText = ({
  property,
  onChange,
  required,
  size = 'small',
}) => {
  const { t } = useTranslation();

  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    if (required) setIsValid(checkValidity());
  }, [property]);

  function checkValidity() {
    const value = property.minValue || '';
    const valid = value.trim().length > 0;
    setIsValid(valid);
    return valid;
  }

  const valueField = {
    label: property.label,
    key: 'minValue',
  };

  function handleUpdate(key, value) {
    const newProp = { ...property, [key]: value };
    onChange(newProp);
  }

  return (
    <FormFieldsHighlightContainer
      error={!isValid}
      field={valueField}
      hasValidation={true}
      hidden={required !== true}
    >
      <TypeRichText
        size={size}
        field={valueField}
        dataCollection={property}
        updateValidationOnChange={handleUpdate}
      />
    </FormFieldsHighlightContainer>
  );
};
